import React, { useEffect, useMemo, useRef, useState } from "react";
import "./SearchableSelect.css";
import { normalizeName } from "../utils/similarity";

// Bağımlılık eklemeden (react-select vb.) yazarak aranabilen, seçenek
// bulunamazsa "+ Yeni Ekle" seçeneği sunan hafif bir combobox.
const SearchableSelect = ({
  options = [],
  value,
  onChange,
  onAddNew,
  placeholder = "Seçiniz",
  addNewLabel = "Yeni Ekle",
  disabled = false,
}) => {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const selectedOption = useMemo(
    () => options.find((o) => o.value === value) || null,
    [options, value]
  );

  useEffect(() => {
    if (!open) {
      setQuery(selectedOption ? selectedOption.label : "");
    }
  }, [selectedOption, open]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const sortedOptions = useMemo(
    () => [...options].sort((a, b) => a.label.localeCompare(b.label, "tr")),
    [options]
  );

  const filtered = useMemo(() => {
    const q = normalizeName(query);
    if (!q) return sortedOptions;
    return sortedOptions.filter((o) => normalizeName(o.label).includes(q));
  }, [sortedOptions, query]);

  const handleSelect = (option) => {
    onChange(option);
    setQuery(option.label);
    setOpen(false);
  };

  const handleAddNewClick = () => {
    setOpen(false);
    onAddNew?.(query.trim());
  };

  return (
    <div className="searchable-select" ref={containerRef}>
      <input
        type="text"
        className="form-control"
        placeholder={placeholder}
        value={query}
        disabled={disabled}
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
          if (!e.target.value) onChange(null);
        }}
      />
      {open && !disabled && (
        <div className="searchable-select-menu">
          {filtered.length === 0 && (
            <div className="searchable-select-empty">Sonuç bulunamadı</div>
          )}
          {filtered.map((option) => (
            <div
              key={option.value}
              className="searchable-select-option"
              onMouseDown={() => handleSelect(option)}
            >
              {option.label}
            </div>
          ))}
          {onAddNew && (
            <div
              className="searchable-select-option searchable-select-add-new"
              onMouseDown={handleAddNewClick}
            >
              + {query.trim() ? `"${query.trim()}" için ${addNewLabel}` : addNewLabel}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
